import { render, staticRenderFns } from "./SidloInput.vue?vue&type=template&id=2eb78d0f&scoped=true&"
import script from "./SidloInput.vue?vue&type=script&lang=js&"
export * from "./SidloInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../bankari hypo/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb78d0f",
  null
  
)

export default component.exports